export default __webpack_public_path__ + "static/media/JAVA.109d8ba2.png";